module.exports = __webpack_public_path__ + "img/kalendar.6dca81b0.svg";